import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const finish = (report_id) => {
      const target = report_id
        ? `/seo/auto-engine?report_id=${report_id}`
        : "/seo/auto-engine";
      navigate(target, { replace: true });
    };

    if (!sessionId) {
      finish();
      return;
    }

    // Preserve any pending report id saved before redirecting to login
    const pendingReport = sessionStorage.getItem("pending_report_id");
    sessionStorage.removeItem("pending_report_id");

    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        setUser(res.data);
        finish(pendingReport);
      })
      .catch(() => {
        finish(pendingReport);
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center">
        <Loader2 className="h-8 w-8 text-primary animate-spin" />
        <p className="mt-3 font-semibold text-slate-700">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
